import gql from "graphql-tag";
import TrailingReturnsFields from "lib/graphql/fragments/TrailingReturnsFields";

export default gql`
  query TrailingReturnsByTickerSymbols($tickerSymbols: [TickerSymbol!]!) {
    trailingReturnsByTickerSymbols(tickerSymbols: $tickerSymbols) {
      tickerSymbol
      trailingReturns {
        ...TrailingReturnsFields
      }
    }
  }

  ${TrailingReturnsFields}
`;
